import axios from "axios";

import { baseURL, getURLWithParams, handleError } from "./util";
import storage from "./storage";

export const getHeaders = () => {
  return {
    accept: "application/json",
    Authorization: `Bearer ${storage.getToken()}`,
    "Content-Type": "application/json",
  };
};

export const apiCall = async ({
  method,
  url,
  data = {},
  queryParams = {},
  headers,
  responseType,
}) => {
  try {
    const apiURL = method === "GET" ? getURLWithParams(url, queryParams) : url;
    const response = await axios({
      baseURL,
      url: apiURL,
      method,
      headers: headers ?? getHeaders(),
      data,
      ...(responseType ? { responseType } : {}),
    });
    if (response && response.status === 200) {
      return response.data;
    } else {
      throw response;
    }
  } catch (error) {
    return handleError(error);
  }
};
